export default "__VITE_ASSET__CXvC0Qh6__"